<div class="table-wrapper">
  <cst-toolbar>
    <ctrl-btn-create (click)="onAddItem()"></ctrl-btn-create>
  </cst-toolbar>
  <tab-formular-zeiterfassung-table [data]="zeiterfassungen" #table>
  </tab-formular-zeiterfassung-table>
</div>